import { useEffect } from 'react';

import { toast } from 'react-toastify';

const UNSAVED_TOAST_INTERVAL_MS = 120000;

/**
 * Периодический тост о несохранённых изменениях, пока форма грязная.
 * toastId не даёт спамить дублями.
 */
export function useUnsavedChangesToast(
  isDirty: boolean,
  message: string,
  toastId: string,
): void {
  useEffect(() => {
    if (!isDirty) return undefined;

    const interval = setInterval(() => {
      toast.warn(message, { toastId });
    }, UNSAVED_TOAST_INTERVAL_MS);

    return () => clearInterval(interval);
  }, [isDirty, message, toastId]);
}
